import axios from 'axios';

import { UniversignValidationCoordonneesRequestSource } from '@/api/placementApi.schemas';
import { API_ROUTE } from '@/constants/apiRoutes';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL_SOUSCRIRE_EN_LIGNE;
const validationCoordonneesEndpoint = API_ROUTE.VALIDATION_COORDONNEES;

interface VersementJustificatifsCoordonneesPostData {
  idSouscription: number;
  email: string;
  telephone: string;
  source: NonNullable<UniversignValidationCoordonneesRequestSource>;
}

export const getFaireVersementJustificatifsCoordonnees = async (
  versementJustificatifsCoordonneesPost: VersementJustificatifsCoordonneesPostData
) => {
  const versementData = sessionStorage.parcoursVersementData
    ? JSON.parse(sessionStorage.parcoursVersementData)
    : {
        token:
          'eyJlcGsiOnsia3R5IjoiT0tQIiwiY3J2IjoiWDI1NTE5IiwieCI6InBabElXTXlZZV9PTzNYYldHcUh5VlVRX3BkZ194YUtZcDRfb2ZRbTN6VlUifSwiYWxnIjoiRUNESC1FUytBMjU2S1ciLCJlbmMiOiJBMjU2Q0JDLUhTNTEyIiwiemlwIjoiREVGIn0.eBBzVRXNnbFwswU3555_3vp55m-f-p13-OywbC5kTp6u1gvGqsCIcOCOHyFhm1RgYJrH2BMQuwfBxmLaf1PL4s9Yn3KbV-Dn.LquxzyEduIRvLO-z8plGrg.2ohURoy6el-WZno-bWOz3KfOpMtLAIlUUdI3pKYM-sj1kK8m8_9P6sms2gqNVfKsaEMJkY6ElNPERQcx-PKA2qOtFGalFxT8xXeHferbQfi3gN_gnflSp2haDuhItGvaaKyNQMxxI5rJazpH3-3T0V6RCUb_NPI17qfCt-xM5HKaLwl45jYtvGDNdADbugHp.sy5OvA84LmklBpcOR1a5rirhIIdx7P6TTE7NqY0ZrxE',
      };

  const response = await axios.post(
    `${apiBaseUrl}${validationCoordonneesEndpoint}`,
    {
      idSouscription: versementJustificatifsCoordonneesPost.idSouscription,
      email: versementJustificatifsCoordonneesPost.email,
      telephone: versementJustificatifsCoordonneesPost.telephone,
      source: versementJustificatifsCoordonneesPost.source,
    },
    {
      headers: {
        token: `${versementData.token}`,
      },
    }
  );

  if (!response) {
    throw new Error("Erreur lors de l'envoie du tel / mail");
  }
  const data = await response.data;
  return data;
};
